import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Available languages type
export type AvailableLanguage = "en" | "pl";

// Available languages constant
export const AVAILABLE_LANGUAGES: AvailableLanguage[] = ["en", "pl"];

// Helper function to check if language is available
export const isAvailableLanguage = (
  language: string,
): language is AvailableLanguage => {
  return AVAILABLE_LANGUAGES.includes(language as AvailableLanguage);
};

// Default language
export const DEFAULT_LANGUAGE: AvailableLanguage = "pl";

// To be refactored:
import translationEN from "./locales/en/translation.json" assert { type: "json" };
import translationPL from "./locales/pl/translation.json" assert { type: "json" };

// Future modules
// TODO: Find a vite plugin and import all locales at once
import clientsPL from "./locales/pl/clients.json" assert { type: "json" };
import clientsEN from "./locales/en/clients.json" assert { type: "json" };
import projectsPL from "./locales/pl/projects.json" assert { type: "json" };
import projectsEN from "./locales/en/projects.json" assert { type: "json" };
import storesPL from "./locales/pl/stores.json" assert { type: "json" };
import storesEN from "./locales/en/stores.json" assert { type: "json" };
import productsPL from "./locales/pl/products.json" assert { type: "json" };
import productsEN from "./locales/en/products.json" assert { type: "json" };
import productGroupsPL from "./locales/pl/productGroups.json" assert { type: "json" };
import productGroupsEN from "./locales/en/productGroups.json" assert { type: "json" };
import servicesAndGoodsPL from "./locales/pl/servicesAndGoods.json" assert { type: "json" };
import servicesAndGoodsEN from "./locales/en/servicesAndGoods.json" assert { type: "json" };
import networksPL from "./locales/pl/networks.json" assert { type: "json" };
import networksEN from "./locales/en/networks.json" assert { type: "json" };
import projectTypesPL from "./locales/pl/projectTypes.json" assert { type: "json" };
import projectTypesEN from "./locales/en/projectTypes.json" assert { type: "json" };
import provincesPL from "./locales/pl/provinces.json" assert { type: "json" };
import provincesEN from "./locales/en/provinces.json" assert { type: "json" };
import storeFormatsPL from "./locales/pl/storeFormats.json" assert { type: "json" };
import storeFormatsEN from "./locales/en/storeFormats.json" assert { type: "json" };
import departmentsPL from "./locales/pl/departments.json" assert { type: "json" };
import departmentsEN from "./locales/en/departments.json" assert { type: "json" };
import departmentBasedProjectRatesPL from "./locales/pl/departmentBasedProjectRates.json" assert { type: "json" };
import departmentBasedProjectRatesEN from "./locales/en/departmentBasedProjectRates.json" assert { type: "json" };
import storeGroupsPL from "./locales/pl/storeGroups.json" assert { type: "json" };
import storeGroupsEN from "./locales/en/storeGroups.json" assert { type: "json" };
import projectStorePeriodsPL from "./locales/pl/projectStorePeriods.json" assert { type: "json" };
import projectStorePeriodsEN from "./locales/en/projectStorePeriods.json" assert { type: "json" };
import projectSettlementsPL from "./locales/pl/projectSettlements.json" assert { type: "json" };
import projectSettlementsEN from "./locales/en/projectSettlements.json" assert { type: "json" };
import projectSettlementsCommentsPL from "./locales/pl/projectSettlementsComments.json" assert { type: "json" };
import projectSettlementsCommentsEN from "./locales/en/projectSettlementsComments.json" assert { type: "json" };
import commentsPL from "./locales/pl/comments.json" assert { type: "json" };
import commentsEN from "./locales/en/comments.json" assert { type: "json" };
import projectSettlementsDirectoryPL from "./locales/pl/projectSettlementsDirectory.json" assert { type: "json" };
import projectSettlementsDirectoryEN from "./locales/en/projectSettlementsDirectory.json" assert { type: "json" };
import projectSettlementsInvoiceSpecificationsPL from "./locales/pl/projectSettlementsInvoiceSpecifications.json" assert { type: "json" };
import projectSettlementsInvoiceSpecificationsEN from "./locales/en/projectSettlementsInvoiceSpecifications.json" assert { type: "json" };
import projectInvoiceSpecificationsPL from "./locales/pl/projectInvoiceSpecifications.json" assert { type: "json" };
import projectInvoiceSpecificationsEN from "./locales/en/projectInvoiceSpecifications.json" assert { type: "json" };
import shiftsPL from "./locales/pl/shifts.json" assert { type: "json" };
import shiftsEN from "./locales/en/shifts.json" assert { type: "json" };
import shiftReportDepartmentsPL from "./locales/pl/shiftReportDepartments.json" assert { type: "json" };
import shiftReportDepartmentsEN from "./locales/en/shiftReportDepartments.json" assert { type: "json" };
import projectStoresPL from "./locales/pl/projectStores.json" assert { type: "json" };
import projectStoresEN from "./locales/en/projectStores.json" assert { type: "json" };
import shiftReportsPL from "./locales/pl/shiftReports.json" assert { type: "json" };
import shiftReportsEN from "./locales/en/shiftReports.json" assert { type: "json" };
import projectRolesPL from "./locales/pl/projectRoles.json" assert { type: "json" };
import projectRolesEN from "./locales/en/projectRoles.json" assert { type: "json" };
import projectRatesPL from "./locales/pl/projectRates.json" assert { type: "json" };
import projectRatesEN from "./locales/en/projectRates.json" assert { type: "json" };
import projectLimitsPL from "./locales/pl/projectLimits.json" assert { type: "json" };
import projectLimitsEN from "./locales/en/projectLimits.json" assert { type: "json" };
import updatesPL from "./locales/pl/updates.json" assert { type: "json" };
import updatesEN from "./locales/en/updates.json" assert { type: "json" };
import projectSchedulesPL from "./locales/pl/projectSchedules.json" assert { type: "json" };
import projectSchedulesEN from "./locales/en/projectSchedules.json" assert { type: "json" };
import hourAllocationTypeEN from "./locales/en/hourAllocationType.json" assert { type: "json" };
import hourAllocationTypePL from "./locales/pl/hourAllocationType.json" assert { type: "json" };
import settlementTypeEN from "./locales/en/settlementType.json" assert { type: "json" };
import settlementTypePL from "./locales/pl/settlementType.json" assert { type: "json" };
import payrollDepartmentsPL from "./locales/pl/payrollDepartments.json" assert { type: "json" };
import payrollDepartmentsEN from "./locales/en/payrollDepartments.json" assert { type: "json" };
import taxOfficesPL from "./locales/pl/taxOffices.json" assert { type: "json" };
import taxOfficesEN from "./locales/en/taxOffices.json" assert { type: "json" };
import citizenshipsPL from "./locales/pl/citizenships.json" assert { type: "json" };
import citizenshipsEN from "./locales/en/citizenships.json" assert { type: "json" };
import disabilityCertificatesPL from "./locales/pl/disabilityCertificates.json" assert { type: "json" };
import disabilityCertificatesEN from "./locales/en/disabilityCertificates.json" assert { type: "json" };
import timesheetEntriesPL from "./locales/pl/timesheetEntries.json" assert { type: "json" };
import timesheetEntriesEN from "./locales/en/timesheetEntries.json" assert { type: "json" };
import payrollTypesPL from "./locales/pl/payrollTypes.json" assert { type: "json" };
import payrollTypesEN from "./locales/en/payrollTypes.json" assert { type: "json" };
import laborCostsInStoresPL from "./locales/pl/laborCostsInStores.json" assert { type: "json" };
import laborCostsInStoresEN from "./locales/en/laborCostsInStores.json" assert { type: "json" };
import contractorVisitsPL from "./locales/pl/contractorVisits.json" assert { type: "json" };
import contractorVisitsEN from "./locales/en/contractorVisits.json" assert { type: "json" };
import projectContractorVisitsPL from "./locales/pl/projectContractorVisits.json" assert { type: "json" };
import projectContractorVisitsEN from "./locales/en/projectContractorVisits.json" assert { type: "json" };
import mobileListPL from "./locales/pl/mobileList.json" assert { type: "json" };
import mobileListEN from "./locales/en/mobileList.json" assert { type: "json" };
import payrollsPL from "./locales/pl/payrolls.json" assert { type: "json" };
import payrollsEN from "./locales/en/payrolls.json" assert { type: "json" };
import homepagePL from "./locales/pl/homepage.json" assert { type: "json" };
import homepageEN from "./locales/en/homepage.json" assert { type: "json" };
import structureAssignmentsPL from "./locales/pl/structureAssignments.json" assert { type: "json" };
import structureAssignmentsEN from "./locales/en/structureAssignments.json" assert { type: "json" };
import agreementCompaniesPL from "./locales/pl/agreementCompanies.json" assert { type: "json" };
import agreementCompaniesEN from "./locales/en/agreementCompanies.json" assert { type: "json" };
import agreementTypesPL from "./locales/pl/agreementTypes.json" assert { type: "json" };
import agreementTypesEN from "./locales/en/agreementTypes.json" assert { type: "json" };
import offlineStatusPL from "./locales/pl/offlineStatus.json" assert { type: "json" };
import offlineStatusEN from "./locales/en/offlineStatus.json" assert { type: "json" };
import contractorsPL from "./locales/pl/contractors.json" assert { type: "json" };
import contractorsEN from "./locales/en/contractors.json" assert { type: "json" };
import agreementsPL from "./locales/pl/agreements.json" assert { type: "json" };
import agreementsEN from "./locales/en/agreements.json" assert { type: "json" };
import questionnairesPL from "./locales/pl/questionnaires.json" assert { type: "json" };
import questionnairesEN from "./locales/en/questionnaires.json" assert { type: "json" };
import roleBasedAssignmentsPL from "./locales/pl/roleBasedAssignments.json" assert { type: "json" };
import roleBasedAssignmentsEN from "./locales/en/roleBasedAssignments.json" assert { type: "json" };
import departmentBasedAssignmentsPL from "./locales/pl/departmentBasedAssignments.json" assert { type: "json" };
import departmentBasedAssignmentsEN from "./locales/en/departmentBasedAssignments.json" assert { type: "json" };
import contractorsAssignmentsPL from "./locales/pl/contractorsAssignments.json" assert { type: "json" };
import contractorsAssignmentsEN from "./locales/en/contractorsAssignments.json" assert { type: "json" };
import usersPL from "./locales/pl/users.json" assert { type: "json" };
import usersEN from "./locales/en/users.json" assert { type: "json" };
import permissionsPL from "./locales/pl/permissions.json" assert { type: "json" };
import permissionsEN from "./locales/en/permissions.json" assert { type: "json" };
import contractorCardsPL from "./locales/pl/contractorCards.json" assert { type: "json" };
import contractorCardsEN from "./locales/en/contractorCards.json" assert { type: "json" };
import contractorPlannedHoursPL from "./locales/pl/contractorPlannedHours.json" assert { type: "json" };
import contractorPlannedHoursEN from "./locales/en/contractorPlannedHours.json" assert { type: "json" };
import contractorStudentsPL from "./locales/pl/contractorStudents.json" assert { type: "json" };
import contractorStudentsEN from "./locales/en/contractorStudents.json" assert { type: "json" };
import defaultStoreProjectAssigneesPL from "./locales/pl/defaultStoreProjectAssignees.json" assert { type: "json" };
import defaultStoreProjectAssigneesEN from "./locales/en/defaultStoreProjectAssignees.json" assert { type: "json" };
import storeProjectAssigneesPL from "./locales/pl/storeProjectAssignees.json" assert { type: "json" };
import storeProjectAssigneesEN from "./locales/en/storeProjectAssignees.json" assert { type: "json" };
import projectManagersPL from "./locales/pl/projectManagers.json" assert { type: "json" };
import projectManagersEN from "./locales/en/projectManagers.json" assert { type: "json" };
import managersPL from "./locales/pl/managers.json" assert { type: "json" };
import managersEN from "./locales/en/managers.json" assert { type: "json" };
import costsPL from "./locales/pl/costs.json" assert { type: "json" };
import costsEN from "./locales/en/costs.json" assert { type: "json" };
import contestAgreementsPL from "./locales/pl/contestAgreements.json" assert { type: "json" };
import contestAgreementsEN from "./locales/en/contestAgreements.json" assert { type: "json" };
import auditLogsPL from "./locales/pl/auditLogs.json" assert { type: "json" };
import auditLogsEN from "./locales/en/auditLogs.json" assert { type: "json" };
import reportsPL from "./locales/pl/reports.json" assert { type: "json" };
import reportsEN from "./locales/en/reports.json" assert { type: "json" };
import contractorsPlannedHoursApprovalsPL from "./locales/pl/contractorsPlannedHoursApprovals.json" assert { type: "json" };
import contractorsPlannedHoursApprovalsEN from "./locales/en/contractorsPlannedHoursApprovals.json" assert { type: "json" };
import contractorsPlannedHoursWizardPL from "./locales/pl/contractorsPlannedHoursWizard.json" assert { type: "json" };
import contractorsPlannedHoursWizardEN from "./locales/en/contractorsPlannedHoursWizard.json" assert { type: "json" };

// ZOD Form locales:
import zodTranslationEN from "zod-i18n-map/locales/en/zod.json" assert { type: "json" };
import zodTranslationPL from "zod-i18n-map/locales/pl/zod.json" assert { type: "json" };

import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      order: ["localStorage", "navigator"],
    },
    resources: {
      en: {
        translation: {
          ...translationEN,
          clients: clientsEN,
          projects: projectsEN,
          projectSettlements: projectSettlementsEN,
          projectSettlementsComments: projectSettlementsCommentsEN,
          comments: commentsEN,
          projectSettlementsDirectory: projectSettlementsDirectoryEN,
          projectSettlementsInvoiceSpecifications:
            projectSettlementsInvoiceSpecificationsEN,
          projectInvoiceSpecifications: projectInvoiceSpecificationsEN,
          stores: storesEN,
          products: productsEN,
          productGroups: productGroupsEN,
          servicesAndGoods: servicesAndGoodsEN,
          networks: networksEN,
          projectTypes: projectTypesEN,
          provinces: provincesEN,
          storeFormats: storeFormatsEN,
          departments: departmentsEN,
          departmentBasedProjectRates: departmentBasedProjectRatesEN,
          storeGroups: storeGroupsEN,
          projectStorePeriods: projectStorePeriodsEN,
          shifts: shiftsEN,
          shiftReportDepartments: shiftReportDepartmentsEN,
          projectStores: projectStoresEN,
          shiftReports: shiftReportsEN,
          projectRoles: projectRolesEN,
          projectLimits: projectLimitsEN,
          projectRates: projectRatesEN,
          updates: updatesEN,
          projectSchedules: projectSchedulesEN,
          hourAllocationType: hourAllocationTypeEN,
          settlementType: settlementTypeEN,
          payrollDepartments: payrollDepartmentsEN,
          taxOffices: taxOfficesEN,
          citizenships: citizenshipsEN,
          disabilityCertificates: disabilityCertificatesEN,
          timesheetEntries: timesheetEntriesEN,
          payrollTypes: payrollTypesEN,
          contractorVisits: contractorVisitsEN,
          projectContractorVisits: projectContractorVisitsEN,
          payrolls: payrollsEN,
          homepage: homepageEN,
          structureAssignments: structureAssignmentsEN,
          agreementCompanies: agreementCompaniesEN,
          agreementTypes: agreementTypesEN,
          laborCostsInStores: laborCostsInStoresEN,
          offlineStatus: offlineStatusEN,
          contractors: contractorsEN,
          agreements: agreementsEN,
          roleBasedAssignments: roleBasedAssignmentsEN,
          departmentBasedAssignments: departmentBasedAssignmentsEN,
          questionnaires: questionnairesEN,
          contractorsAssignments: contractorsAssignmentsEN,
          mobileList: mobileListEN,
          users: usersEN,
          permissions: permissionsEN,
          contractorCards: contractorCardsEN,
          contractorPlannedHours: contractorPlannedHoursEN,
          contractorStudents: contractorStudentsEN,
          defaultStoreProjectAssignees: defaultStoreProjectAssigneesEN,
          storeProjectAssignees: storeProjectAssigneesEN,
          projectManagers: projectManagersEN,
          managers: managersEN,
          costs: costsEN,
          contestAgreements: contestAgreementsEN,
          auditLogs: auditLogsEN,
          reports: reportsEN,
          contractorsPlannedHoursApprovals: contractorsPlannedHoursApprovalsEN,
          contractorsPlannedHoursWizard: contractorsPlannedHoursWizardEN,
        },
        zod: zodTranslationEN,
      },
      pl: {
        translation: {
          ...translationPL,
          clients: clientsPL,
          projects: projectsPL,
          projectSettlements: projectSettlementsPL,
          projectSettlementsComments: projectSettlementsCommentsPL,
          comments: commentsPL,
          projectSettlementsDirectory: projectSettlementsDirectoryPL,
          projectSettlementsInvoiceSpecifications:
            projectSettlementsInvoiceSpecificationsPL,
          projectInvoiceSpecifications: projectInvoiceSpecificationsPL,
          stores: storesPL,
          products: productsPL,
          productGroups: productGroupsPL,
          servicesAndGoods: servicesAndGoodsPL,
          networks: networksPL,
          projectTypes: projectTypesPL,
          provinces: provincesPL,
          storeFormats: storeFormatsPL,
          departments: departmentsPL,
          departmentBasedProjectRates: departmentBasedProjectRatesPL,
          storeGroups: storeGroupsPL,
          projectStorePeriods: projectStorePeriodsPL,
          shifts: shiftsPL,
          shiftReportDepartments: shiftReportDepartmentsPL,
          projectStores: projectStoresPL,
          shiftReports: shiftReportsPL,
          projectRoles: projectRolesPL,
          projectLimits: projectLimitsPL,
          projectRates: projectRatesPL,
          updates: updatesPL,
          projectSchedules: projectSchedulesPL,
          hourAllocationType: hourAllocationTypePL,
          settlementType: settlementTypePL,
          payrollDepartments: payrollDepartmentsPL,
          taxOffices: taxOfficesPL,
          citizenships: citizenshipsPL,
          disabilityCertificates: disabilityCertificatesPL,
          timesheetEntries: timesheetEntriesPL,
          payrollTypes: payrollTypesPL,
          contractorVisits: contractorVisitsPL,
          projectContractorVisits: projectContractorVisitsPL,
          payrolls: payrollsPL,
          homepage: homepagePL,
          structureAssignments: structureAssignmentsPL,
          agreementCompanies: agreementCompaniesPL,
          agreementTypes: agreementTypesPL,
          laborCostsInStores: laborCostsInStoresPL,
          offlineStatus: offlineStatusPL,
          contractors: contractorsPL,
          agreements: agreementsPL,
          roleBasedAssignments: roleBasedAssignmentsPL,
          departmentBasedAssignments: departmentBasedAssignmentsPL,
          questionnaires: questionnairesPL,
          contractorsAssignments: contractorsAssignmentsPL,
          mobileList: mobileListPL,
          users: usersPL,
          permissions: permissionsPL,
          contractorCards: contractorCardsPL,
          contractorPlannedHours: contractorPlannedHoursPL,
          contractorStudents: contractorStudentsPL,
          defaultStoreProjectAssignees: defaultStoreProjectAssigneesPL,
          storeProjectAssignees: storeProjectAssigneesPL,
          projectManagers: projectManagersPL,
          managers: managersPL,
          costs: costsPL,
          contestAgreements: contestAgreementsPL,
          auditLogs: auditLogsPL,
          reports: reportsPL,
          contractorsPlannedHoursApprovals: contractorsPlannedHoursApprovalsPL,
          contractorsPlannedHoursWizard: contractorsPlannedHoursWizardPL,
        },
        zod: zodTranslationPL,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
